import { createElement as rc } from 'react';
// eslint-disable-next-line import/extensions
import _App from './App.js';

export default props => {
    return rc(_App, props);
};
